import type { Checklist } from '@cobliteam/api-lib';

import { type ITableColumn, PlaceholderText } from '@cobliteam/base-components';

export const VehicleColumn = (): ITableColumn<Checklist> => ({
  id: 'context.vehicle',
  label: 'Veículo',
  sortable: true,
  orderByKey: (row) => row.context?.vehicle?.licensePlate || '',
  Cell: (row) => {
    if (row.context) {
      const { vehicle } = row.context;
      if (vehicle?.licensePlate && vehicle.model) {
        const { licensePlate, model } = vehicle;
        return `${licensePlate} - ${model}`;
      }

      if (vehicle?.licensePlate) {
        const { licensePlate } = vehicle;
        return licensePlate;
      }
    }
    return <PlaceholderText>Sem associação</PlaceholderText>;
  },
});

export default VehicleColumn;
